import { Pipe, PipeTransform } from '@angular/core';
import { IUser } from 'src/app/models/user';

@Pipe({
  name: 'userfordropdown'
})
export class UserfordropdownPipe implements PipeTransform {

  transform(value: IUser, ...args: any[]): string {
    let result = '';
    result = [value.userPrincipalName  === null || value.userPrincipalName === undefined  ? false : value.userPrincipalName?.split('@')[0],
    value.email  === null || value.email === undefined  ? false : value.email,
    value.jobTitle  === null || value.jobTitle === undefined ? false : value.jobTitle,
    value.extension_8b4e685f580748b59864d62c2e7fcfad_employeeNumber === null || value.extension_8b4e685f580748b59864d62c2e7fcfad_employeeNumber === undefined ? false : value.extension_8b4e685f580748b59864d62c2e7fcfad_employeeNumber,
    value.phone  === null || value.phone === undefined  ? false : value.phone,
    ].filter(Boolean).join(' - ');
    return result;
  }
}
